import React, { Component } from 'react';
import NewsService from '../../src/services/News.service';
import NewsConfiguration from '../../src/models/NewsConfiguration';
import Cookies from 'universal-cookie';
import NewsModalMobilePage from './views/pages/NewsModalMobilePage';
import NewsModalDesktopPage from './views/pages/NewsModalDesktopPage';

type AppProps = {
  region: string;
}

type AppState = {
    configuration: NewsConfiguration,
    seenNews: string[],
    width: number,
}
export default class App extends Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);
        this.state = {
          configuration: new NewsConfiguration(),
          seenNews: [],
          width: window.innerWidth,
        };
      }

      public async componentDidMount() {
        const cookies = new Cookies();
        const seenNews = cookies.get('seenNewsModal');

        const service: NewsService = new NewsService();
        const configuration: NewsConfiguration = await service.getConfiguration(this.props.region);

        if (!seenNews || !configuration.articles.some(article => !this.state.seenNews.includes(article.nodeGUID))) {
          for (let article of configuration.articles) {
            const html = await service.getContent(article.nodeGUID);
            article.html = html;
          }
        }

        this.setState({
          configuration: configuration,
          seenNews: seenNews ?? [],
        });
      }

      componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
      }

      // make sure to remove the listener
      // when the component is not mounted anymore
      componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
      }

      handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
      };

      public render() {
        const newArticles = this.state.configuration.articles.filter(article => !this.state.seenNews.includes(article.nodeGUID));

        return (
          <>
            {
              this.state.configuration.articles.length > 0 &&
              newArticles.length > 0 &&
              <div>
                {
                  this.state.width < 768
                  ? <NewsModalMobilePage configuration={this.state.configuration} articles={newArticles}></NewsModalMobilePage>
                  : <NewsModalDesktopPage configuration={this.state.configuration} articles={newArticles}></NewsModalDesktopPage>

                }
              </div>
            }
          </>
        );
      }
}